import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmActionDialogComponent } from 'src/app/shared/components/confirm-action-dialog/confirm-action-dialog.component';
import { TranslateService } from '@ngx-translate/core';

interface Topic {
  topic: string,
  text: string
}

export interface NotificationTopics {
  notifications: Topic[],
  kairon: Topic[],
  maia: Topic[]
}
export interface ConfiguredTopics {
  notifications: string[],
  kairon: string[],
  maia: string[]
}
export interface DialogData {
  availableTopics: NotificationTopics,
  currentTopics: ConfiguredTopics,
  isUser: boolean;
  name: string;
  events: boolean;
  isKaironEnabled: boolean;
  isMaiaEnabled: boolean;
}

@Component({
  selector: 'app-notification-form',
  templateUrl: './notification-form.component.html',
  styleUrls: ['./notification-form.component.scss'],
})
export class NotificationFormComponent {
  public topicsList: {
    notifications: {
      topic: string;
      text: string;
      selected: boolean;
    }[],
    kairon: {
      topic: string;
      text: string;
      selected: boolean;
    }[],
    maia: {
      topic: string;
      text: string;
      selected: boolean;
    }[]
  }

  constructor(
    private readonly dialogRef: MatDialogRef<NotificationFormComponent>,
    private readonly translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog
  ) {
    dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => {
      this.onCancelClick();
    });

    this.topicsList = {
      notifications: [],
      kairon: [],
      maia: []
    };
    this.processNotificationConfiguration('notifications');
    if (this.data.isUser) {
      this.processNotificationConfiguration('kairon');
      this.processNotificationConfiguration('maia');
    }
  }

  processNotificationConfiguration(key: string): void {
    this.data.availableTopics[key]?.forEach((t) => {
      this.topicsList[key].push({
        topic: t.topic,
        text: t.text,
        selected:
          this.data.currentTopics[key] && this.data.currentTopics[key].length > 0
            ? this.data.currentTopics[key].includes(t.topic)
            : false,
      });
    });
  }

  openConfirmDialog(promptText: string, submitText: string, callback: Function): void {
    const dialogRef = this.dialog.open(ConfirmActionDialogComponent, {
      maxWidth: '450px',
      autoFocus: false,
      data: { promptText, submitText },
    });

    dialogRef.afterClosed().subscribe((result) => callback(result));
  }

  parseTopics = (notificationConfig) => {
    const notifications = {};
    notificationConfig.forEach((t) => {
      notifications[t.topic] = t.selected;
    });
    return notifications;
  };

  async submit() {
    const topics = {
      notifications: this.parseTopics(this.topicsList.notifications),
      kairon: this.parseTopics(this.topicsList.kairon),
      maia: this.parseTopics(this.topicsList.maia)
    }

    if (this.data.isUser || this.data.events) {
      this.dialogRef.close({ status: 'success', topics });
    } else {
      this.openConfirmDialog(
        await this.translateService.get('NotForm.ModifPartitionSett').toPromise(),
        await this.translateService.get('Shared.Accept').toPromise(),
        (result: boolean) => {
          if (result) {
            this.dialogRef.close({ status: 'success', topics });
          }
        }
      );
    }
  }

  onCancelClick = async () => {
    this.openConfirmDialog(
      await this.translateService.get('NotForm.ExitForm').toPromise(),
      await this.translateService.get('Shared.Leave').toPromise(),
      (result: boolean) => {
        if (result) {
          this.dialogRef.close({ status: 'cancel' });
        }
      }
    );
  };
}
